<template>
  <table id="tabela-valores" class="w-full text-center">
    <template v-for="(serie, index) in LINHAS">
      <tr :key="index" v-if="index !== 'referencias'" :class="index" :title="nomes[index]">
        <td style="width: 3.65% !important;">
          <div class="quadrado-17 border-full mx-auto" :style="{background: cores[index]}">&nbsp;</div>
        </td>

        <template v-for="(value, index1) in serie">
          <td
            :key="`${index}-${value}-${index1}`"
            style="width: 7.23% !important;"
            @click="$emit('click:celula', {index_linha: index, index_coluna: index1})"
          >
            {{ Helpers.formatarValor(value || 0) }}
          </td>
        </template>
      </tr>
    </template>
  </table>
</template>

<script>
import {cores, nomes} from "@/components/Diagnostico/CurvasCruzadas/IndicadorEvolucao/InformacoesGrafico";

export default {
  name: "Grid",
  props: {
    dados: Object,
    series: Object
  },
  data: ()=> ({
    cores,
    nomes
  }),
  computed: {
    LINHAS() {
      return this.dados
    }
  }
}
</script>

<style scoped>
#tabela-valores {
  border-collapse: collapse;
}
#tabela-valores tr td {
  text-align: center;
  padding: 5px 0;
  font-size: 12px;
  color: #3a3a3a;
}
.border-full {
  border: 1px solid #939292;
}
.total_aumentar:hover {
  background: rgba(35, 158, 222, 0.35);
}
.estoque_parametrizavel:hover {
  background: rgba(105, 206, 13, 0.5);
}
.total_estoque:hover {
  background: #e6e6e6
}
.diferenca:hover {
  background: rgba(206, 21, 229, 0.25);
}
.total_reduzir:hover {
  background: rgba(255, 16, 16, 0.3);
}
</style>
